import { createSlice} from "@reduxjs/toolkit";


const initialState = {
    term: '',
    page: 1,
    perPage: 10,
    fields: ['title','chapter_title','body'],
    exactSearch: false,
    facets: {},
    searchFacets: {},
}

const yearbookSearchSlice = createSlice({
    name: 'yearbookSearch',
    initialState,
    reducers: {
        setTerm(state, action) {
            state.term = action.payload;
        },
        setPage(state, action) {
            state.page = action.payload;
        },
        setPerPage(state, action) {
            state.perPage = action.payload;
        },
        setFields(state, action) {
            state.fields = action.payload;
        },
        setExactSearch(state, action) {
            state.exactSearch = action.payload;
        },
        setFacets(state, action) {
            state.facets = action.payload;
        },
        setSearchFacets(state, action) {
            state.searchFacets = action.payload;
        },
    }
});

export const {
    setTerm,
    setPage,
    setPerPage,
    setFields,
    setExactSearch,
    setFacets,
    setSearchFacets,
} = yearbookSearchSlice.actions;

export default yearbookSearchSlice.reducer;


